<template>
  <v-container class="account-access-container">
    <v-card class="elevation-3 rounded-lg pa-4">
      <div class="account-access-faqs">
        <!-- Account Access FAQs Section -->
        <h2 class="text-h5 font-weight-bold primary--text mb-4">
          Account Access FAQs
        </h2>

        <v-expansion-panels flat>
          <!-- Login Issues FAQ -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              I can't sign in to my account. What should I do?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text class="pa-1">
                <p class="body-1 mb-3">
                  If you're having trouble signing in, it could be due to an
                  incorrect password.
                </p>
                <v-list dense class="flex-wrap">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-key</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap"
                        >You can <strong>reset your password</strong> by
                        clicking the <strong>"Forgot Password"</strong> link on
                        the login page.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap"
                        >Still having issues? If you no longer have access to
                        the email or phone number linked to your account, please
                        contact our <strong>Customer Service team</strong> for
                        assistance:</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-alert
                  text
                  color="info"
                  icon="mdi-email-outline"
                  class="mt-4"
                >
                  <!-- Mobile Only -->
                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium d-inline d-md-none"
                  >
                    clientsupport
                  </a>

                  <!-- Desktop Only -->
                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium d-none d-md-inline"
                  >
                    clientsupport@centuryfinancialservices.net
                  </a>
                </v-alert>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Change Phone Number FAQ -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              How can I change my phone number on my account?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p class="body-1 mb-3">To update your phone number:</p>
                <v-stepper vertical>
                  <v-stepper-step step="1" complete>
                    <strong>Log in</strong> to your account
                  </v-stepper-step>
                  <v-stepper-content step="1"> </v-stepper-content>

                  <v-stepper-step step="2" complete>
                    Go to the <strong>"My Details"</strong> section
                  </v-stepper-step>
                  <v-stepper-content step="2"> </v-stepper-content>

                  <v-stepper-step step="3" complete>
                    Enter your <strong>new phone number</strong> and save the
                    changes
                  </v-stepper-step>
                  <v-stepper-content step="3"> </v-stepper-content>
                </v-stepper>

                <v-card outlined class="pa-3 mt-4 mb-4">
                  <v-card-text class="pa-0">
                    <p class="body-1 mb-0">
                      <v-icon small color="primary">mdi-cellphone</v-icon>
                      Please ensure your new number is accurate, as your Century
                      account is linked to it for all communications and
                      verifications.
                    </p>
                  </v-card-text>
                </v-card>

                <v-divider class="my-4"></v-divider>

                <h4 class="subtitle-1 font-weight-bold mb-2">
                  <v-icon color="error">mdi-block-helper</v-icon>
                  <strong> No access to your account?</strong>
                </h4>
                <p class="body-1 mb-3">
                  If you're unable to log in, contact our Customer Service team
                  for support:
                </p>

                <v-alert
                  text
                  color="info"
                  icon="mdi-email-outline"
                  class="mt-2"
                >
                  <!-- Mobile Only -->
                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium d-inline d-md-none"
                  >
                    clientsupport
                  </a>

                  <!-- Desktop Only -->
                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium d-none d-md-inline"
                  >
                    clientsupport@centuryfinancialservices.net
                  </a>
                </v-alert>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AccountAccessComponent",
  data() {
    return {
      // No specific data items needed for this component currently
    };
  },
};
</script>

<style scoped>
.account-access-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 24px;
}
</style>
